import { render, staticRenderFns } from "./DailyRecord.vue?vue&type=template&id=2828ed87&scoped=true"
import script from "./DailyRecord.vue?vue&type=script&lang=js"
export * from "./DailyRecord.vue?vue&type=script&lang=js"
import style0 from "./DailyRecord.vue?vue&type=style&index=0&id=2828ed87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2828ed87",
  null
  
)

export default component.exports